// extracted by mini-css-extract-plugin
export default {"page":"Page_page__yRruf","pageBlue":"Page_pageBlue__VXhw8"};